import { reactive } from 'vue';

const store = reactive({
  search: ''
});

export default store;